export default __webpack_public_path__ + "static/media/pirentz-desktop-landing.90046207.png";